import { connect } from 'react-redux';

import ProductListPage from '../components/pages/product-list';

import BaseProductList from './base/base-product-list';

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch) => ({

});

const ProductListConnector = connect(mapStateToProps, mapDispatchToProps)(ProductListPage);

export default BaseProductList(ProductListConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/product-list-connector.js
 **/